import { TEST, SUCCESS } from './type'

const mockReducer = (state = { foo: 'test' }, action) => {
  switch (action.type) {
    case TEST:
      return {
        ...state,
        foo: '',
      }
    case SUCCESS:
      return {
        ...state,
        foo: 'ssssss',
      }
    default:
      return state
  }
}


export default mockReducer
